"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptionType = void 0;
/**
 * Encryption algorithm type to used in cryptography
 */
var EncryptionType;
(function (EncryptionType) {
    /**
     * Edwards-curve digital signature algorithm.
     * It is recommended to use this over Secp256k1 due to its security and performance.
     */
    EncryptionType["Ed25519"] = "ed25519";
    /**
     * The default algorithm used by BitCoin, Ethereum, and many other cryptocurrencies.
     */
    EncryptionType["Secp256k1"] = "secp256k1";
})(EncryptionType || (exports.EncryptionType = EncryptionType = {}));
